import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59557a85"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100 h-100" }
const _hoisted_2 = { style: {"margin-left":"1%"} }
const _hoisted_3 = { style: {"display":"inline-block","margin":"1% auto 0% auto","border":"none"} }
const _hoisted_4 = { style: {"width":"400px","border":"none"} }
const _hoisted_5 = { style: {"width":"300px"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  class: "adjusting-option",
  value: 0
}, "*ALL", -1 /* HOISTED */))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  class: "adjusting-option",
  value: 1
}, "Your tasks", -1 /* HOISTED */))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { style: {"width":"100px"} }
const _hoisted_10 = {
  id: "divNextPage",
  style: {"text-align":"right"}
}
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"permissionDiv0 w-100\" data-v-59557a85><table id=\"tblPermissionInfo\" style=\"width:calc(100% - 16px);\" data-v-59557a85><thead data-v-59557a85><tr data-v-59557a85><th style=\"width:7%;\" data-v-59557a85>User ID</th><th style=\"width:8%;\" data-v-59557a85>Given Name</th><th style=\"width:8%;\" data-v-59557a85>Family Name</th><th style=\"width:13%;\" data-v-59557a85>E-mail</th><th style=\"width:7%;\" data-v-59557a85>Department</th><th style=\"width:13%;\" data-v-59557a85>Station Code</th><th style=\"width:13%;\" data-v-59557a85>Main Title</th><th style=\"width:15%;\" data-v-59557a85>Permission</th><th style=\"width:8%;\" data-v-59557a85>Approval</th><th style=\"width:8%;\" data-v-59557a85>Deny</th></tr></thead></table></div>", 1)
const _hoisted_12 = {
  key: 0,
  style: {"width":"calc(100% - 16px)","height":"calc(97% - 200px)"}
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "No data", -1 /* HOISTED */))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  id: "tblPermisdiv",
  style: {"overflow":"auto","height":"calc(97% - 200px)"}
}
const _hoisted_16 = {
  id: "tblPermissionInfo",
  class: "w-100"
}
const _hoisted_17 = { id: "tblPermistbody" }
const _hoisted_18 = ["rowspan"]
const _hoisted_19 = ["rowspan"]
const _hoisted_20 = ["rowspan"]
const _hoisted_21 = ["rowspan"]
const _hoisted_22 = ["rowspan"]
const _hoisted_23 = ["rowspan"]
const _hoisted_24 = ["rowspan"]
const _hoisted_25 = { style: {"width":"15%"} }
const _hoisted_26 = { style: {"width":"8%"} }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { style: {"width":"8%"} }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = {
  class: "modal fade",
  id: "showModal",
  tabindex: "-1",
  "aria-labelledby": "showModalLabel",
  "aria-hidden": "true",
  style: {"width":"30%","margin-left":"35%"}
}
const _hoisted_31 = {
  class: "modal-dialog modal-dialog-scrollable modal-lg",
  style: {"height":"auto"}
}
const _hoisted_32 = { class: "modal-content" }
const _hoisted_33 = { class: "modal-header" }
const _hoisted_34 = {
  class: "modal-title",
  id: "showModalLabel"
}
const _hoisted_35 = {
  class: "modal-body",
  id: "modal-body-news-faq"
}
const _hoisted_36 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Loading"], { isLoading: $setup.isLoading }, null, 8 /* PROPS */, ["isLoading"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["Alert"], {
        alertMessage: $setup.alertMessage,
        alertState: $setup.alertState
      }, null, 8 /* PROPS */, ["alertMessage", "alertState"])
    ]),
    _createVNode($setup["AdminNavigation"], { menuTile: $setup.title }, null, 8 /* PROPS */, ["menuTile"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", _hoisted_4, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_5, [
              _withDirectives(_createElementVNode("select", {
                class: "form-select approval-search-form-select",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedCondition) = $event))
              }, _hoisted_8, 512 /* NEED_PATCH */), [
                [_vModelSelect, $setup.selectedCondition]
              ])
            ]),
            _createElementVNode("td", _hoisted_9, [
              _createElementVNode("button", {
                type: "button",
                class: "btnMenuApprovalSearch",
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.goSearchByCondition()))
              }, "Go")
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("a", {
        style: {"color":"blue","cursor":"pointer","text-decoration":"underline"},
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.goToApprovalHistory()))
      }, "Approval History >>")
    ]),
    _hoisted_11,
    ($setup.permisInfo.length == 0 && $setup.isNoData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
      : (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("table", _hoisted_16, [
            _createElementVNode("tbody", _hoisted_17, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.permisInfo[0], (info, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.permisInfoListByUserId, (rowInfo, rowIndex) => {
                    return (_openBlock(), _createElementBlock("tr", { key: rowIndex }, [
                      (rowIndex == 0)
                        ? (_openBlock(), _createElementBlock("td", {
                            key: 0,
                            style: {"width":"7%"},
                            rowspan: info.rowspanCount
                          }, _toDisplayString(info.userId), 9 /* TEXT, PROPS */, _hoisted_18))
                        : _createCommentVNode("v-if", true),
                      (rowIndex == 0)
                        ? (_openBlock(), _createElementBlock("td", {
                            key: 1,
                            style: {"width":"8%"},
                            rowspan: info.rowspanCount
                          }, _toDisplayString(info.givenName), 9 /* TEXT, PROPS */, _hoisted_19))
                        : _createCommentVNode("v-if", true),
                      (rowIndex == 0)
                        ? (_openBlock(), _createElementBlock("td", {
                            key: 2,
                            style: {"width":"8%"},
                            rowspan: info.rowspanCount
                          }, _toDisplayString(info.familyName), 9 /* TEXT, PROPS */, _hoisted_20))
                        : _createCommentVNode("v-if", true),
                      (rowIndex == 0)
                        ? (_openBlock(), _createElementBlock("td", {
                            key: 3,
                            style: {"width":"13%"},
                            rowspan: info.rowspanCount
                          }, _toDisplayString(info.email), 9 /* TEXT, PROPS */, _hoisted_21))
                        : _createCommentVNode("v-if", true),
                      (rowIndex == 0)
                        ? (_openBlock(), _createElementBlock("td", {
                            key: 4,
                            style: {"width":"7%"},
                            rowspan: info.rowspanCount
                          }, _toDisplayString(info.department), 9 /* TEXT, PROPS */, _hoisted_22))
                        : _createCommentVNode("v-if", true),
                      (rowIndex == 0)
                        ? (_openBlock(), _createElementBlock("td", {
                            key: 5,
                            style: {"width":"13%"},
                            rowspan: info.rowspanCount
                          }, _toDisplayString(info.stationCode + "-" + info.companyName), 9 /* TEXT, PROPS */, _hoisted_23))
                        : _createCommentVNode("v-if", true),
                      (rowIndex == 0 || (rowIndex != 0 && rowInfo.mainTitleName != info.permisInfoListByUserId[rowIndex - 1].mainTitleName))
                        ? (_openBlock(), _createElementBlock("td", {
                            key: 6,
                            style: {"width":"13%"},
                            rowspan: rowInfo.titleRowSpan
                          }, _toDisplayString(rowInfo.mainTitleName), 9 /* TEXT, PROPS */, _hoisted_24))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("td", _hoisted_25, _toDisplayString(rowInfo.mainMenuName), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_26, [
                        (rowInfo.isAccess)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn btn-primary button-design-scanPermission",
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#showModal",
                              onClick: ($event: any) => ($setup.rowParam(info, rowInfo, $setup.approveStatus))
                            }, " Approve ", 8 /* PROPS */, _hoisted_27))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createElementVNode("td", _hoisted_28, [
                        (rowInfo.isAccess)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn btn-primary button-design-scanPermission",
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#showModal",
                              onClick: ($event: any) => ($setup.rowParam(info, rowInfo, $setup.denyStatus))
                            }, " Deny ", 8 /* PROPS */, _hoisted_29))
                          : _createCommentVNode("v-if", true)
                      ])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 64 /* STABLE_FRAGMENT */))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ])),
    _createCommentVNode(" Modal "),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("h5", _hoisted_34, _toDisplayString($setup.modalSubject), 1 /* TEXT */),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.clearRowParam()))
            })
          ]),
          _createElementVNode("div", _hoisted_35, _toDisplayString($setup.modalBody), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                id: "modelCancel",
                type: "button",
                class: "btn btn-secondary",
                "data-bs-dismiss": "modal",
                onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.clearRowParam()))
              }, " Close "),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary button-design",
                style: {"width":"100px","margin-left":"20px"},
                "data-bs-dismiss": "modal",
                onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.permisApproveDeny()))
              }, _toDisplayString($setup.buttonText), 1 /* TEXT */)
            ])
          ])
        ])
      ])
    ])
  ]))
}